import { PencilLine, Trash } from '@phosphor-icons/react'
import { useDeleteMoreFee } from 'api/league/LeagueCostAndFee/CostAndFee'
import AlertModal from 'helper/AlertModal'
import React, { useState } from 'react'
import { leagueEventStore } from 'state/league/leagueEvent'
import { AdditionalFeeResp } from 'types/event/eventStep3'

const AdditionalFee: React.FC = () => {
  const { leagueData, setLeagueData, setFeeModal, feeData, setFeeData } =
    leagueEventStore(store => ({
      leagueData: store.leagueData,
      setLeagueData: store.setLeagueData,
      setFeeModal: store.setFeeModal,
      feeData: store.additionalFeeData,
      setFeeData: store.setAdditionalFeeData,
    }))
  const [openAlertModal, setOpenAlertModal] = useState<boolean>(false)
  const { mutate: deleteMutation, isLoading: deleteMutationLoading } =
    useDeleteMoreFee()

  const alertModalData = {
    name: 'Additional fee',
    heading: 'Delete this fee',
    message1: `Are you sure you want to delete this fee?`,
  }

  const handleEdit = (fee: AdditionalFeeResp) => {
    setFeeData(fee)
    setFeeModal(true)
  }

  const handleDelete = (fee: AdditionalFeeResp) => {
    setFeeData(fee)
    setOpenAlertModal(true)
  }

  const onYesClick = () => {
    deleteMutation(
      {
        leagueId: leagueData._id,
        feeId: feeData._id,
      },
      {
        onSuccess: updatedData => {
          setLeagueData({
            ...leagueData,
            ...updatedData,
          })
          setOpenAlertModal(false)
        },
      },
    )
  }

  return (
    <>
      {leagueData?.additionalFee.length > 0 && (
        <>
          <div className="mt-10px">
            {leagueData?.additionalFee.map((fee: AdditionalFeeResp) => {
              return (
                <div className="flex justify-between align-center mt-10px gap-16px">
                  <div className="flex align-center gap-16px">
                    <h3 className="text-14 w-600 text-darkBlue">{fee.name}</h3>
                    <PencilLine
                      size={20}
                      color="#000"
                      className="pointer"
                      onClick={() => handleEdit(fee)}
                    />
                    <Trash
                      size={20}
                      color={'#FF6961'}
                      onClick={() => handleDelete(fee)}
                      className="pointer"
                    />
                  </div>
                  <h3 className="text-14 w-600 text-darkBlue">
                    {`${
                      fee?.price
                        ? `$${fee.price.toFixed(2)}`
                        : `$${fee?.priceRange?.min.toFixed(
                            2,
                          )} ~ ${fee?.priceRange?.max.toFixed(2)}`
                    }`}
                  </h3>
                </div>
              )
            })}
          </div>

          {openAlertModal && (
            <AlertModal
              isModalVisible={openAlertModal}
              setIsModalVisible={setOpenAlertModal}
              data={alertModalData}
              onYesClick={onYesClick}
              loading={deleteMutationLoading}
            />
          )}
        </>
      )}
    </>
  )
}

export default AdditionalFee
